import { Group, Label } from '@radix-ui/react-dropdown-menu'
import React from 'react'

export interface DropdownMenuSectionProps {
  children: React.ReactNode;
  title?: string;
}
export function DropdownMenuSection ({
  children,
  title,
}: DropdownMenuSectionProps) {
  return (
    <Group className='mt-1.5 pt-1 first:mt-0 border-t first:border-none border-gray-200'>
      {!!title && (
        <Label className='px-2 py-1 text-xs font-medium text-gray-500'>
          {title}
        </Label>
      )}
      {children}
    </Group>
  )
}
